import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';

import Main from '../../../layouts/Main';
import Container from '../../../components/Container';
import {Card, Divider, List, ListItem, Link} from '@mui/material';
import PageBreadcrumbs from '../../../components/PageBreadcrumbs';
import { Margin } from '@mui/icons-material';

const JobPostings = (): JSX.Element => {

  const bulletListStyle = {
    listStyleType: "disc",
    pl: 3,
    "& li": {
      display: "list-item",
      textIndent: "-0.5em", // tighten bullet spacing
      paddingBottom: 0,
      marginBottom: 0,
    },
    "& li::marker": {
      fontSize: "1.5em",  // adjust bullet size
    },
  };

  return (
    <Main>
      <Container>
        <PageBreadcrumbs></PageBreadcrumbs>
        <Typography
            variant="h5"
            align={'left'}
            sx={{
                fontWeight: 700,
            }}
            paddingTop={3}
            gutterBottom
            marginBottom={2}
            >
            Career Opportunities
        </Typography>
        <Divider/>
        <Grid container marginTop={3}>
            <Grid 
              padding={3}
              size={12}
              component={Card}
              boxShadow={1}
              >
                <Typography variant='subtitle1'>There are no job openings at this time. Please check back later. </Typography>
            </Grid>
        </Grid>
        {/* previous post */}
        {
          false &&
          <Grid container marginTop={3}>
            <Grid 
              padding={3}
              size={12}
              component={Card}
              boxShadow={1}
              >

              {/* Title */}
              <Typography variant="h5" gutterBottom fontWeight={550}>
                IT and Data Support Specialist
              </Typography>

              {/* Description */}
              <Typography variant="h6" gutterBottom marginTop={3} fontWeight={550}>
                Description
              </Typography>
              <Typography variant='body1'>
                  Massachusetts Office of Campaign and Political Finance (OCPF) is seeking
                  a candidate to join our small IT team to support our IT systems and
                  infrastructure, custom applications, and 16 desktop users. Assist with
                  internal hardware support, custom software technical support for our
                  clients and staff, and help with network administration support. This
                  role spans endpoint and infrastructure administration, security and
                  backups, ticket and request management, web development support,
                  document and processes development, generating analytical reports, and
                  developing user-friendly educational tools for both internal and
                  external stakeholders.
              </Typography>

              {/* Qualifications */}
              <Typography variant="h6" gutterBottom marginTop={3} fontWeight={550}>
                Qualifications
              </Typography>

              <Typography variant="subtitle1" gutterBottom fontWeight={550}>
                Key Requirements
              </Typography>
              <List dense  sx={bulletListStyle}>
                <ListItem>Degree in computer science or equivalent experience preferred.</ListItem>
                <ListItem>3+ years in an IT-related field (support or software-related).</ListItem>
              </List>

              <Typography variant="subtitle1" gutterBottom fontWeight={550} marginTop={3}>
                Preferred Qualifications / Technical Skills
              </Typography>
              <List dense sx={bulletListStyle}>
                <ListItem>
                  Proficiency in Microsoft SQL Server or equivalent relational databases
                  (e.g., Oracle, PostgreSQL, MySQL), including basic querying
                  capabilities.
                </ListItem>
                <ListItem>
                  Experience with ServiceNow, Dropbox, GitHub, and Adobe Acrobat DC forms.
                </ListItem>
                <ListItem>
                  Strong working knowledge of Windows Server, Windows 10+, and Microsoft Office Suite.
                </ListItem>
                <ListItem>
                  Familiarity with major web browsers (Internet Explorer, Firefox,Chrome).
                </ListItem>
                <ListItem>
                  Hands-on experience with installation, configuration, and maintenance of networking components, operating systems, and computer hardware.
                </ListItem>
                <ListItem>
                  Working knowledge of Active Directory, Exchange administration, IIS, and core networking protocols (TCP/IP, DHCP, DNS, VPN, HTTP), including firewalls and proxy servers.
                </ListItem>
                <ListItem>
                  Understanding of Azure administration, security principles, backup strategies, and storage systems.
                </ListItem>
                <ListItem>
                  Basic programming literacy (C#, JavaScript) and exposure to web application development and testing.
                </ListItem>
                <ListItem>
                  Excellent customer service and interpersonal skills; comfortable engaging with clients and cross-functional teams.
                </ListItem>
                <ListItem>
                  Ability to manage multiple deadlines with strong organizational, analytical, and problem-solving skills. Works well independently and
                  collaboratively to meet team goals with precision and efficiency.
                </ListItem>
                <ListItem>
                  Strong written and verbal communication skills, with the ability to produce clear technical documentation for non-technical audiences.
                </ListItem>
                <ListItem>
                  Commitment to maintaining confidentiality and handling sensitive information appropriately.
                </ListItem>
                <ListItem>
                  Preferred experience with web development workflows, accessibility standards, end-to-end testing tools (e.g., Playwright), and cloud
                  platforms such as Azure and AWS.
                </ListItem>
              </List>

              {/* Responsibilities */}
              <Typography variant="h6" gutterBottom marginTop={3} fontWeight={550}>
                Responsibilities Include but Are Not Limited To
              </Typography>
              <List dense sx={bulletListStyle}>
                <ListItem>
                  Provide phone-based technical support for the agency’s flagship electronic filing application.
                </ListItem>
                <ListItem>
                  Deliver internal IT support for desktop workstations, laptops, printers, scanners, phones, and other peripherals, including VPN
                  connectivity, network infrastructure (Wi-Fi, routers, firewalls,
                  cabling), and hardware acquisition and maintenance.
                </ListItem>
                <ListItem>
                  Coordinate staff onboarding and offboarding processes; manage internal data requests and external public records inquiries.
                </ListItem>
                <ListItem>
                  Administer Active Directory and Exchange environments, including mailbox and group management, policy enforcement, and credential/access
                  control across multiple platforms.
                </ListItem>
                <ListItem>
                    Conduct functional testing of internally developed software applications.
                </ListItem>
                <ListItem>
                  Maintain and support cloud-based infrastructure on Azure, including patch management, security hardening, and firewall configuration for
                  SQL Server connectivity.
                </ListItem>
                <ListItem>
                  Collaborate on enhancements to public-facing websites and applications, focusing on accessibility, usability, and issue resolution.
                </ListItem>
                <ListItem>
                  Ensure reliable backup and security protocols for both cloud and on-premises databases.
                </ListItem>
                <ListItem>
                  Assist in gathering business requirements and producing documentation for new and ongoing technology projects.
                </ListItem>
                <ListItem>
                  Support the maintenance and updates of multiple web applications.
                </ListItem>
                <ListItem>
                  Conduct technology evaluations to assess tools and applications for organizational fit.
                </ListItem>
                <ListItem>
                  Serve as liaison between the agency and the Massachusetts Executive Office of Technology Services and Security (EOTSS).
                </ListItem>
                <ListItem>Perform additional duties as assigned by the Director or Chief Information Officer.</ListItem>
              </List>

              {/* Compensation */}
              <Typography variant="h6" gutterBottom marginTop={3} fontWeight={550}>
                Compensation
              </Typography>
              <Typography variant='body1'>
                This is a full-time, exempt, at-will position not covered by a collective
                bargaining agreement or civil service regulations. The role offers an
                excellent benefits package. The starting salary range is $70,000 to
                $80,000, commensurate with qualifications and experience. This is
                currently a hybrid position, requiring three in-office days per week in
                Boston. The posting will remain open until the position is filled.
              </Typography>

              {/* Background Check */}
              <Typography variant="h6" gutterBottom marginTop={5} fontWeight={550}>
                Notice of Background Check
              </Typography>
              <Typography variant='body1'>
                The Agency requires a background check on all prospective employees as a
                condition of employment. Candidates should be aware of this requirement
                but should also know that such a background check is not initiated until:
              </Typography>
              <List dense sx={bulletListStyle}>
                <ListItem>
                  A candidate is invited to a second or subsequent interview; and
                </ListItem>
                <ListItem>
                  The candidate has signed the Criminal Offender Record Information(CORI) Acknowledgement Form.
                </ListItem>
              </List>

              <Typography>
                This background check includes a check of Criminal Offender Record
                Information on all prospective employees as a condition of their
                employment. Individuals other than those references provided by a
                candidate may be contacted while a full background and qualification
                check is completed.
              </Typography>

            <Typography variant="h6" gutterBottom marginTop={5}>
              OCPF is an Equal Opportunity Employer and does not discriminate based on protected characteristics such as race, color, religion, sex, sexual orientation, national origin, age, disability, or veteran status.
            </Typography>

            {/* Contact */}
              <Typography variant="body1" gutterBottom marginTop={3}>
                      Please submit a letter of interest and resume to Chief Financial Officer,{" "}
                        Brittany Johnson at{" "}
                        <Link href="mailto:brittany.johnson@mass.gov">
                          brittany.johnson@mass.gov
                        </Link>
              </Typography>
            </Grid>
          </Grid>
        }
      </Container>
    </Main>
  );
};

export default JobPostings;